import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { ConfigurationService } from '../ConfigurationService';

export class LaunchConfigAccessor {
	// private workspaceConfiguration: WorkspaceConfiguration;
	private configurationService: ConfigurationService;
	public constructor(
		_workspaceConfiguration: WorkspaceConfiguration,
		configurationService: ConfigurationService
	) {
		// this.workspaceConfiguration = workspaceConfiguration;
		this.configurationService = configurationService;
	}

	private shouldDelayPostLaunchStepForHybridLaunches(
		isLaunchSuccessful: boolean,
		isNative: boolean
	): boolean {
		return (
			isLaunchSuccessful &&
			this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
				FeatureFlag.EnablePostLaunchDelayForHybridLaunches
			) &&
			!isNative
		);
	}

	public getPostLaunchDelayForHybridLaunchesInMs(
		isLaunchSuccessful: boolean,
		isNative: boolean
	): number {
		return this.shouldDelayPostLaunchStepForHybridLaunches(isLaunchSuccessful, isNative)
			? 5000
			: 0; // 5 seconds
	}
}
